import styled from "styled-components";

export const ServiceContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: auto;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const ServicePaper = styled.div`
  background: #fff;
  color: #101e8e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
`;

export const ServiceTitle = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: space-between;
  background: #d8d8d8;
  color: #101e8e;
  padding: 0.2rem;
`;

export const ServicePaperSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90%;
`;

export const ServicePaperSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  min-height: 130px;
  .main {
    width: calc(100% - 33.33%);
  }
  .data {
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px dashed #101e8e;
    &:last-child{
        border-bottom: none;
    }
  }
`;
